module.exports = __webpack_public_path__ + "img/gn.88e73865.svg";